/**
 * Espelho, no frontend, da regra de conexao permitida do backend.
 *
 * 🔴 REGRA OPERACIONAL: este arquivo e o backend
 * (`backend/src/helpers/GetUserAllowedWhatsappIds.ts`) mudam NO MESMO COMMIT, ou
 * nao mudam. Front mais frouxo que o back = o card entra pelo socket e some no
 * F5. Front mais duro = some da tela e reaparece na busca. Nos dois casos o
 * atendente conclui que "o sistema esta bugado" — e ele tem razao.
 *
 * ⚠️ MANTEM O FALLBACK de `user.whatsappId`, que o upstream apagou. Sem ele, o
 * usuario LEGADO (whatsappId preenchido, zero linhas em UserWhatsapps) passaria a
 * ser tratado como "sem restricao" e veria tudo.
 *
 * ⚠️ Nota sobre o `user` no front: o socket `company-<id>-user` NAO devolve o
 * SerializeUser — ele emite o objeto montado a mao no fim do UpdateUserService,
 * que traz `profile`, `whatsapps` e `whatsappId` (o que este helper precisa)
 * mas DESCARTA `super` e `token`. Como o front faz `setUser(data.user)`
 * substituindo o objeto inteiro, nao dependa aqui de campo que some depois que o
 * admin salva o usuario.
 */

export function getUserAllowedWhatsappIds(user) {
  if (!user) return [];
  const fromRelation = (user.whatsapps || [])
    .map(w => Number(w?.id))
    .filter(id => Number.isInteger(id) && id > 0);
  if (fromRelation.length > 0) return fromRelation;
  const defaultId = Number(user.whatsappId);
  if (Number.isInteger(defaultId) && defaultId > 0) return [defaultId];
  return [];
}

export function userCanSeeTicketConnection(user, ticket) {
  // O bypass e' IDENTICO ao do backend (userHasWhatsappAccess): so' "admin".
  // NAO acrescentar `user.super` — o backend nao trata super, e qualquer
  // divergencia aqui vira lista que se contradiz ao recarregar a pagina.
  if (!user || user.profile === "admin") return true;

  const allowed = getUserAllowedWhatsappIds(user);
  // Sem amarracao = ve tudo. E' o caso da MAIORIA da frota; restringir aqui
  // faria o painel abrir vazio para quase todo mundo.
  if (allowed.length === 0) return true;

  const waId = Number(ticket?.whatsappId || ticket?.whatsapp?.id || 0);
  // ⚠️ TICKET SEM CONEXAO: aqui e' fail-OPEN (mostra), mas a LISTA do backend e'
  // fail-CLOSED — `Op.in` nunca casa com NULL, entao esses tickets somem da lista,
  // do badge e do relatorio. A divergencia e' conhecida e esta' registrada de
  // proposito, em vez de "corrigida" no escuro:
  //   - o `userHasWhatsappAccess` (usado pelo push) devolve true com whatsappId
  //     null, entao o push TOCA para esses tickets;
  //   - quem manda na lista e' o `applyUserWhatsappFilter`, que FECHA.
  // Quando isso acontece: a migration de Tickets.whatsappId usa
  // onDelete:"SET NULL" — apagar uma conexao zera o campo em todos os tickets
  // dela. Resultado para usuario amarrado: o ticket some da lista mas o celular
  // apita. Nao e' regressao (o front nao tinha filtro nenhum antes), mas nao
  // acredite no comentario antigo que dizia "igual ao backend": nao e'.
  if (!waId) return true;

  return allowed.includes(waId);
}

export default userCanSeeTicketConnection;
